import React, { useState, useCallback } from 'react';
import Lightbox from "react-image-lightbox";
import SpinnerImg from '../../assets/spinner.gif';

// Force the browser to repaint the compositing layer.
// On mobile WebKit, large images loaded into CSS-transformed containers
// sometimes don't trigger a layer repaint, leaving a blank screen until
// the user scrolls/pinches. A double rAF flushes the pending paint.
const forceRepaint = () => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const el = document.querySelector('.ril-inner');
            if (!el) return;
            // Reading offsetHeight forces a layout flush
            // eslint-disable-next-line no-unused-expressions
            el.offsetHeight;
            // Briefly toggle will-change to invalidate the compositing layer
            el.style.willChange = 'transform';
            requestAnimationFrame(() => {
                el.style.willChange = '';
            });
        });
    });
};

export function MediaGalleryLightBox ({ images, index, setIndex }) {

    const currentImage = images[index];
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    const Spinner = () => (
      <div className="spinner">
        <img src={SpinnerImg} alt="Loading" />
        <p>Loading...</p>
      </div>
    );

    return (
        <div>
            {!!currentImage && (
                <Lightbox
                    mainSrc={currentImage.original}
                    imageCaption={currentImage.caption}
                    mainSrcThumbnail={currentImage.original}
                    nextSrc={nextImage.original}
                    nextSrcThumbnail={nextImage.original}
                    prevSrc={prevImage.original}
                    prevSrcThumbnail={prevImage.original}
                    onCloseRequest={handleClose}
                    onMovePrevRequest={handleMovePrev}
                    onMoveNextRequest={handleMoveNext}
                    loader={<Spinner />}
                    onAfterOpen={forceRepaint}
                    onImageLoad={forceRepaint}
                />
            )}
        </div>
    );
}
